import i18n from '../i18n';
import { formatNumber } from '../i18n/format';

export const CREDIT_SCALE = 1_000_000;

export type BrandKey = 'amazon' | 'apple' | 'steam' | 'uber' | 'grab' | 'spotify' | 'deposit';

export type Voucher = {
    id: string;
    brand: string;
    key: Exclude<BrandKey, 'deposit'>;
    amount: number;
    region: string;
    date: string;
    code: string;
};

export type Product = {
    id: Exclude<BrandKey, 'deposit'>;
    name: string;
    from: number;
    word: string;
};

export type Transaction = {
    id: string;
    type: 'purchase' | 'deposit';
    brand: string;
    key: BrandKey;
    amount: number;
    status: string;
    date: string;
    voucherId?: string;
};

export const HOME_PROFILE = {
    fullName: 'Alex Lee',
    availableCreditUnits: 1_248_500_000,
    reservedCreditUnits: 25_000_000,
};

export const HOME_VOUCHERS: Voucher[] = [
    {
        id: 'v1',
        brand: 'Amazon',
        key: 'amazon',
        amount: 25,
        region: 'United States',
        date: '15 Sep 2026',
        code: 'DEMO-AMZN-25-ONLY',
    },
    {
        id: 'v2',
        brand: 'Steam',
        key: 'steam',
        amount: 50,
        region: 'United States',
        date: '12 Sep 2026',
        code: 'DEMO-STEAM-50-ONLY',
    },
];

export const HOME_PRODUCTS: Product[] = [
    { id: 'amazon', name: 'Amazon', from: 10, word: 'amazon' },
    { id: 'apple', name: 'Apple', from: 10, word: 'Apple' },
    { id: 'steam', name: 'Steam', from: 10, word: 'STEAM' },
    { id: 'uber', name: 'Uber', from: 15, word: 'Uber' },
];

export const HOME_ACTIVITY: Transaction[] = [
    {
        id: 'a1',
        type: 'purchase',
        brand: 'Apple',
        key: 'apple',
        amount: 25,
        status: 'Processing',
        date: 'Today, 16:32',
    },
    {
        id: 'a2',
        type: 'purchase',
        brand: 'Amazon',
        key: 'amazon',
        amount: -25,
        status: 'Delivered',
        date: 'Today, 14:08',
        voucherId: 'v1',
    },
    {
        id: 'a3',
        type: 'deposit',
        brand: 'USDT deposit',
        key: 'deposit',
        amount: 250,
        status: 'Confirmed',
        date: 'Yesterday, 09:41',
    },
    {
        id: 'a4',
        type: 'purchase',
        brand: 'Steam',
        key: 'steam',
        amount: -50,
        status: 'Delivered',
        date: '12 Sep, 18:20',
        voucherId: 'v2',
    },
];

export function formatCredits(value: number): string {
    return formatNumber(Number(value), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}

export function formatCreditUnits(units: number): string {
    return formatCredits(units / CREDIT_SCALE);
}

export function getGreeting(date = new Date()): string {
    const hour = date.getHours();
    if (hour < 12) return i18n.t('greeting.morning', { ns: 'home' });
    if (hour < 18) return i18n.t('greeting.afternoon', { ns: 'home' });
    return i18n.t('greeting.evening', { ns: 'home' });
}
